import { HeadCell, JOB_TRANSACTION_TYPE } from 'models';

export enum AC_JOB_TRANSACTION_TYPE {
  PARENT_BASE_CHARGE = 'parent_base_charge',
  SITTER_BASE_FEE = 'sitter_base_fee',
  PARENT_SURCHARGE_ODD_HOUR = 'parent_surcharge_odd_hour',
  SITTER_SURCHARGE_ODD_HOUR = 'sitter_surcharge_odd_hour',
  PARENT_SURCHARGE_MORE_CHILD = 'parent_surcharge_more_child',
  SITTER_SURCHARGE_MORE_CHILD = 'sitter_surcharge_more_child',
  PARENT_SURCHARGE_WEEKEND = 'parent_surcharge_weekend',
  SITTER_SURCHARGE_WEEKEND = 'sitter_surcharge_weekend',
  PARENT_SURCHARGE_PUBLIC_HOLIDAY = 'parent_surcharge_public_holiday',
  SITTER_SURCHARGE_PUBLIC_HOLIDAY = 'sitter_surcharge_public_holiday',
  PARENT_CANCEL_FEE = 'parent_cancel_fee',
  SITTER_CANCEL_FEE = 'sitter_cancel_fee',
}

export const LABEL_TXN_TYPE = {
  [AC_JOB_TRANSACTION_TYPE.PARENT_BASE_CHARGE]: 'Parent Base Charge',
  [AC_JOB_TRANSACTION_TYPE.SITTER_BASE_FEE]: 'Sitter Base Fee',
  [AC_JOB_TRANSACTION_TYPE.PARENT_SURCHARGE_ODD_HOUR]:
    'Parent Surcharge Odd Hour',
  [AC_JOB_TRANSACTION_TYPE.SITTER_SURCHARGE_ODD_HOUR]:
    'Sitter Surcharge Odd Hour',
  [AC_JOB_TRANSACTION_TYPE.PARENT_SURCHARGE_MORE_CHILD]:
    'Parent Surcharge More Child',
  [AC_JOB_TRANSACTION_TYPE.SITTER_SURCHARGE_MORE_CHILD]:
    'Sitter Surcharge More Child',
  [AC_JOB_TRANSACTION_TYPE.PARENT_SURCHARGE_WEEKEND]:
    'Parent Surcharge Weekend',
  [AC_JOB_TRANSACTION_TYPE.SITTER_SURCHARGE_WEEKEND]:
    'Sitter Surcharge Weekend',
  [AC_JOB_TRANSACTION_TYPE.PARENT_SURCHARGE_PUBLIC_HOLIDAY]:
    'Parent Surcharge Public Holiday',
  [AC_JOB_TRANSACTION_TYPE.SITTER_SURCHARGE_PUBLIC_HOLIDAY]:
    'Sitter Surcharge Public Holiday',
  [AC_JOB_TRANSACTION_TYPE.PARENT_CANCEL_FEE]: 'Parent Cancel Fee',
  [AC_JOB_TRANSACTION_TYPE.SITTER_CANCEL_FEE]: 'Sitter Cancel Fee',
};

export const headCells: readonly HeadCell<JOB_TRANSACTION_TYPE>[] = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    isSort: false,
    label: 'TXN No.',
  },
  {
    id: 'type',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'TXN Type',
  },
  {
    id: 'description',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Description',
  },
  {
    id: 'duration',
    numeric: true,
    disablePadding: false,
    isSort: false,
    label: 'Duration (hours)',
  },
  {
    id: 'amount',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Amount',
  },
  {
    id: 'createdAt',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Transaction Date',
  },
];
